import React from 'react';
import {Header, Breadcrumb, Container,Loader, Dropdown, Divider, Form, Dimmer, TextArea,   Button, Grid,Input, Radio} from 'semantic-ui-react';
import { Link } from "react-router-dom";


const FormularioForm=({ id, color, form, onSave,onChange, ajaxCallInProgress, datos, errors={}, strings, permisos})=>{



	return (
        <Container>
          <Dimmer active={ajaxCallInProgress>0?true:false} inverted>
          		<Loader size='big' inline content={strings?strings["Procesando"]:""}/>
          </Dimmer>

				<Header     dividing>             
					<Header.Content>{strings?strings["Formulario"]:""}</Header.Content>
				</Header>
			<Grid container>
                <Grid.Row>
                    <Grid.Column >
                        <Form  >          
                            <Form.Field  required  error={errors.nombreFormulario}>            
                              <label  >{strings?strings["nombreFormulario"]:""}</label>
                              <Input 
                                    placeholder={strings?strings["nombreFormulario"]:""} 
                                    name="nombreFormulario"
                                    onChange={onChange}
                                    value={datos.nombreFormulario}
                                    icon='edit'/>
                            </Form.Field>
                                            
                            <Form.Field  required  error={errors.titulo}>            
                              <label  >{strings?strings["titulo"]:""}</label>
                              <Input 
                                    placeholder={strings?strings["titulo"]:""} 
                                    name="titulo"
                                    onChange={onChange}
                                    value={datos.titulo}
                                    icon='edit'/>
                            </Form.Field>
                                            
                            <Form.Field  required  error={errors.nota}>            
                              <label  >{strings?strings["nota"]:""}</label>
                              <Input 
                                    placeholder={strings?strings["nota"]:""} 
                                    name="nota"
                                    onChange={onChange}
                                    value={datos.nota}
                                    icon='edit'/>
                            </Form.Field>
                                                                        
                            <Divider hidden/>
							  <Grid centered>
                            <Button.Group  >
                                <Link to="/formularios">
                                    <Button  
										>{strings?strings["regresar"]:""}</Button>
                                </Link>
                                <Button.Or text=" "></Button.Or>
                                <Button  color="black"
                                    onClick={onSave}>{strings?strings["guardar"]:""}
								 </Button>
                              </Button.Group>
                            </Grid>
                           <br/>
                        </Form>
                    </Grid.Column>
                </Grid.Row>
                
            
            </Grid>
        
        </Container>
	);
};



export default FormularioForm;